import React from "react";
import { OverlayViewF, OverlayView } from "@react-google-maps/api";

const CENTER = (w, h) => ({ x: -(w / 2), y: -(h / 2) });

/* 施工地址图钉：鲜亮实心点 + 白边 + 持续扩散的光晕（CSS 动画，见 index.css .engmap-pin）；选中放大、路线站点显示序号 */
export const PulsePin = ({ p, color, on, ord, title, onClick }) => (
  <OverlayViewF position={{ lat: p.lat, lng: p.lng }} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET} getPixelPositionOffset={CENTER} zIndex={on ? 999 : ord ? 500 : 1}>
    <button type="button" className="engmap-pin" style={{ "--pin": ord ? "#111827" : color }} data-on={on ? "1" : "0"} data-ord={ord || undefined} title={title}
      onClick={(e) => { e.stopPropagation(); onClick?.(); }} data-testid={`eng-map-pin-${p.id}`}>
      <span className="engmap-pin-halo" />
      <span className="engmap-pin-halo engmap-pin-halo--2" />
      <span className="engmap-pin-dot">{ord || ""}</span>
    </button>
  </OverlayViewF>
);
